function Footer() {
	return (
		<footer className="bg-700-fade-reverse">
			<div className="row w-100 py-3 mt-5">
				<div className="col-12 text-center">
					Feito com ❤️ & ✨ por{" "}
					<a
						href="http://github.com/srclayton"
						target="_blank"
						rel="noreferrer"
					>
						/srclayton
					</a>
					<br />
					<a
						href="https://github.com/srclayton"
						target="_blank"
						className="mx-1"
						rel="noreferrer"
					>
						<img src="/assets/github.svg" alt="" />
					</a>
					<a
						href="https://www.linkedin.com/in/srclayton"
						target="_blank"
						className="mx-1"
						rel="noreferrer"
					>
						<img src="/assets/linkedin-in.svg" alt="" />
					</a>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
